<template>
	<v-flex xs10 offset-xs1>
		<v-card>
			<v-card-text>
				<v-data-iterator
					:items="projects"
					:items-per-page.sync="itemsPerPage"
					:footer-props="{ itemsPerPageOptions }"
					:search="search"
				>
					<template v-slot:header>
						<v-text-field
							v-model="search"
							clearable
							outlined
							prepend-inner-icon="mdi-magnify"
							label="Поиск проекта..."
							autofocus
						></v-text-field>
					</template>
					<template v-slot:default="props">
						<v-row>
							<v-col
								v-for="item in props.items"
								:key="item.name"
								cols="12"
								sm="6"
								md="4"
								lg="3"
							>
								<v-card @click="changePageInner(item.project)">
									<v-card-title><h4>{{ item.label }}</h4></v-card-title>
									<v-divider></v-divider>
									<v-list dense>
										<v-list-item>
											<v-list-item-content>Выборка:</v-list-item-content>
											<v-list-item-content class="align-end">{{ item.rows }}</v-list-item-content>
										</v-list-item>
										<v-divider></v-divider>
										<v-list-item v-if="item.concepts.length">
											<v-list-item-content>
												<strong>Концепции:</strong>
												<router-link
													class="concept-block"
													v-for="concept in item.concepts" :key="concept"
													:to="{name: 'ProjectPageConcept', params: {name: item.project, concept: concept}}"
												>
													<div class="concept-item">{{concept}}</div>
												</router-link>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-card>
							</v-col>
						</v-row>
					</template>
				</v-data-iterator>
			</v-card-text>
		</v-card>
	</v-flex>
</template>

<script>
  export default {
    name: "MainPage",
    data: () => {
      return {
        search: '',
        itemsPerPageOptions: [6, 12, 24],
        itemsPerPage: 12,
      }
    },
    props: {
      projects: Array,
      changePage: Function,
      getProjects: Function,
    },
    methods: {
      changePageInner: function (project) {
        this.changePage({name: 'ProjectPage', params: {name: project}})
      }
    },
    mounted: function () {
      this.getProjects();
    },
  }
</script>

<style scoped>
	.concept-block {
		display: inline;
		text-decoration: none;
		color: #a6a6a6;
		text-align: left;
	}
	
	.concept-block:hover {
		color: #565656;
	}
</style>
